import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatEventDate } from "../../lib/api";
import { Plus, PencilSimple, Trash } from "@phosphor-icons/react";

const AdminNews = () => {
  const [articles, setArticles] = useState([]);
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/admin/news").then(({ data }) => setArticles(data));
  useEffect(() => { load(); }, []);

  const createNew = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/admin/news", {
        title: "Untitled article",
        excerpt: "",
        body: "",
        category: "Marketing",
        author: "FintechOmni Editorial",
        source: "FintechOmni",
        published_at: new Date().toISOString(),
        status: "draft",
        featured: false,
        read_time_min: 4,
        tags: [],
      });
      window.location.href = `/admin/news/${data.id}`;
    } finally { setBusy(false); }
  };

  const remove = async (id) => {
    if (!window.confirm("Delete this article?")) return;
    await api.delete(`/admin/news/${id}`);
    load();
  };

  return (
    <div data-testid="admin-news-page">
      <div className="flex items-end justify-between mb-8 flex-wrap gap-4">
        <div>
          <div className="term-label">/ newsroom</div>
          <h1 className="font-display font-black tracking-tighter text-4xl sm:text-5xl mt-2">All articles.</h1>
        </div>
        <button onClick={createNew} disabled={busy} className="btn-neon" data-testid="create-news-btn">
          <Plus size={14} weight="bold" /> {busy ? "Creating..." : "New article"}
        </button>
      </div>

      <div className="hard-border">
        <div className="grid grid-cols-12 gap-2 px-5 py-3 border-b border-cyber-line bg-cyber-elevated font-mono-tech text-[10px] tracking-[0.2em] uppercase text-white/60">
          <div className="col-span-5">Title</div>
          <div className="col-span-2">Category</div>
          <div className="col-span-2">Published</div>
          <div className="col-span-1">Status</div>
          <div className="col-span-2 text-right">Actions</div>
        </div>
        {articles.length === 0 && <div className="px-5 py-8 text-white/50 font-mono-tech">/ no articles yet.</div>}
        {articles.map((a) => (
          <div key={a.id} className="grid grid-cols-12 gap-2 px-5 py-4 border-b border-cyber-line items-center" data-testid={`news-row-${a.id}`}>
            <div className="col-span-5">
              <div className="text-white truncate">{a.title}</div>
              <div className="font-mono-tech text-xs text-white/40 truncate">/{a.slug}</div>
            </div>
            <div className="col-span-2 font-mono-tech text-xs text-white/70">{a.category}</div>
            <div className="col-span-2 font-mono-tech text-xs text-white/70">{formatEventDate(a.published_at)}</div>
            <div className="col-span-1">
              <span className={`font-mono-tech text-xs px-2 py-1 border ${a.status === 'published' ? 'border-cyber-green text-cyber-green' : 'border-white/30 text-white/60'}`}>{a.status}</span>
              {a.featured && <span className="font-mono-tech text-xs px-2 py-1 ml-1 border border-white text-white">★</span>}
            </div>
            <div className="col-span-2 flex items-center justify-end gap-3">
              <Link to={`/admin/news/${a.id}`} className="text-white hover:text-cyber-green" data-testid={`edit-news-${a.id}`}><PencilSimple size={16} /></Link>
              <button onClick={() => remove(a.id)} className="text-cyber-red hover:text-white" data-testid={`delete-news-${a.id}`}><Trash size={16} /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminNews;
